import { create } from "zustand";

export interface PendingSendIntent {
  tenantId: string;
  scriptIds: string[];
  briefIds?: string[];
  /** Present when the connection already exists (send or re-sign resume). */
  tenantVendorId?: string;
  /** Present when the user must connect before sending can continue. */
  vendorId?: string;
}

interface PendingSendState {
  intent: PendingSendIntent | null;
  setIntent: (intent: PendingSendIntent) => void;
  clearIntent: () => void;
}

export const usePendingSendStore = create<PendingSendState>((set) => ({
  intent: null,
  setIntent: (intent) => set({ intent }),
  clearIntent: () => set({ intent: null }),
}));
